import { ComponentStyleConfig } from "@chakra-ui/react";

export const Text: ComponentStyleConfig = {
	defaultProps: {
		variant: "solid",
		fontFamily: "Roboto",
	},
};
